import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import DropdownList from 'components/controls/DropdownList';
import { Button } from 'antd';
import _notification from 'modules/notification';
import { Card, Table, Modal, Tag, Input, Switch, Radio, Pagination, Checkbox } from 'antd';
import ConfirmPopup from '../popup/ConfirmPopup';
import MyInput from 'components/controls/MyInput';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';
import moment from 'moment';
import CandidateReview from './CandidateReview';
import ButtonComponent from 'components/controls/Button';
import { instance } from '../../modules/ApiRequest';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import EmptyState from 'components/enterprise/EmptyState';
import StatusBadge from 'components/enterprise/StatusBadge';
import _csvExport from 'modules/csvExport';
import PageHeader from 'components/enterprise/PageHeader';
import { routesAdmin } from 'routes/Routes';
const { Search } = Input;


class TransactionsList_new extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: { pageSize: 100, current: 1, total: 0 },
            highlightedRowID: 0,
            data: [],
            rowData: {},
            loading: false,
            showMessageBox: false,
            totalRowCount: 0,
            searchTerm: "",
        };
    }

    componentDidMount() {
        console.clear();
        this.getAllRazorPayTransactions();
    }

    //API operations
    getAllRazorPayTransactions = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let defaultParam = { pageIndex: 1, pageSize: this.state.pagination.pageSize, searchTerm: "", sortBy: 'TransactionDate', orderBy: 'DESC' };
                    let candidateList = await _AdminService.GetAllRazorPayTransactions(defaultParam);
                    let searchedData = candidateList.data;
                    this.setState({
                        ...this.state,
                        data: searchedData.List,
                        pagination: { ...this.state.pagination, total: searchedData.TotalRecords },
                        totalRowCount: searchedData.TotalRecords,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    search = async () => {
        try {
            //console.log(this.state.searchTerm, 'pagination: ', this.state.pagination);
            this.setState({ loading: true }, async () => {
                try {

                    let defaultParam = { pageIndex: this.state.pagination.current, pageSize: this.state.pagination.pageSize, searchTerm: this.state.searchTerm, sortBy: 'TransactionDate', orderBy: 'DESC' };
                    let candidateList = await _AdminService.GetAllRazorPayTransactions(defaultParam);

                    let searchedData = candidateList.data;

                    this.setState({
                        ...this.state,
                        data: searchedData.List,
                        pagination: { ...this.state.pagination, total: searchedData.TotalRecords },
                        totalRowCount: searchedData.TotalRecords,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    onSearch = (value) => {
        this.setState({ searchTerm: value, pagination: { ...this.state.pagination, current: 1 }, });
        this.search();
    }

    onSearchTextChange = ({ target: { name, value } }) => {
        this.setState({
            ...this.state,
            searchTerm: value
        });
    }

    onPageChange = (pageNumber) => {
        //console.log(pageNumber);
        this.setState({ pagination: { ...this.state.pagination, current: pageNumber }, });
        this.search();
    }

    onRefundClick = (value) => {
        //console.log('params ', value);
        this.setState({ rowData: value, showMessageBox: true, highlightedRowID: 0 });
    };

    onShowSizeChange = (current, pageSize) => {
        //console.log(current, pageSize);
        this.setState({ pagination: { ...this.state.pagination, current: 1, pageSize: pageSize }, });
        this.search();
    };

    onExportCsv = () => {
        const columns = [
            { title: 'Form #', dataIndex: 'FormNumber' },
            { title: 'Application ID', dataIndex: 'ApplicationId' },
            { title: 'Name', dataIndex: 'StudentName' },
            { title: 'Applied Post', dataIndex: 'PostName' },
            { title: 'Mode', dataIndex: 'Method' },
            { title: 'Payment Date', dataIndex: (row) => moment(row.TransactionDate).isValid() ? moment(row.TransactionDate).format("DD MMM YYYY, h:mm:ss A") : "" },
            { title: 'Payment ID', dataIndex: 'RazorPayPaymentId' },
            { title: 'Amount', dataIndex: (row) => row.Amount && (row.Amount / 100) },
            { title: 'Status', dataIndex: 'TransactionStatus' },
            { title: 'Code', dataIndex: 'Error_Code' },
            { title: 'Reason', dataIndex: 'Error_Reason' }
        ];
        _csvExport.exportToCsv(`transactions-page-${this.state.pagination.current}.csv`, columns, this.state.data);
    };

    closeMessageBox(value = false) {
        this.setState({ showMessageBox: value });
    }

    onRefundModel = (value) => {
        //console.log('reached in delete:  ', value);
        this.setState({ showMessageBox: false });
        this.onInitiateRefund(value);
    }

    onInitiateRefund = (item) => {
        //console.log(item);
        try {

            //console.log(this.state.searchTerm, 'pagination: ', this.state.pagination);
            this.setState({ loading: true }, async () => {
                try {

                    const response = await _AdminService.RefundTransaction(item.RazorPayPaymentId);

                    if (response.status == 200 && response.data.IsSuccess) {
                        _notification.showMessage('success', `Refund initiated successfully.`);
                        this.setState({
                            loading: false,
                            highlightedRowID: item.Id
                        });
                        this.search();
                    }
                    else {
                        _notification.showMessage('error', response.data.Message);
                    }

                    this.setState({
                        loading: false,
                    });
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }


    render() {
        const refundModel = (<Modal
            centered={true}
            width={400}
            className="modelPopAnt admin-home"
            visible={this.state.showMessageBox}
            onCancel={() => this.closeMessageBox(false)}
            footer={false}
        >
            <ConfirmPopup
                onCancel={() => this.closeMessageBox(false)}
                onOk={this.onRefundModel}
                popupData={this.state.rowData}
                message="Are you sure, you want to refund this transaction as per candidate request?"
            />
        </Modal>);

        if (this.state.loading)
            return <LoadingSpinner />

        return (


                <div className="container-fluid p-3 admin-custom-table mb-4">
                    <PageHeader
                        title="Transactions"
                        breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Transactions' }]}
                    />
                    <div className="ent-panel mb-3">
                        <div className="search-wrap pb-3">
                            <Search
                                placeholder="Search Form No., Name, Applied Post, Payment ID / Mode / Status"
                                allowClear
                                onSearch={this.onSearch}
                                value={this.state.searchTerm}
                                onChange={this.onSearchTextChange}
                                style={{
                                    width: 460,
                                    paddingLeft: '7px'
                                }}
                            />
                            <Button
                                size='small'
                                onClick={this.onExportCsv}
                                disabled={!this.state.data.length}
                                className="button-global button-secondary ml-2 autoHeight"
                                title="Exports only the currently loaded page of results"
                            >Export current page (CSV)</Button>
                        </div>
                    </div>
                        <div className="custom-table-wrap  admin-table table-striped-rows ent-panel">
                            <div className=" analysisWrap ant-table-small" >
                                <div className="ant-table-content">
                                    <div className="ant-table-body">
                                        <table className='customTable table-striped-rows whiteBg' id="myTable">
                                        <thead className="ant-table-thead">
                                            <tr className='stickyDivTranColumnHeader'>
                                                <th style={{ width: '5%' }}>Form #</th>
                                                <th style={{ width: '5%' }}>Application ID</th>
                                                <th style={{ width: '12%' }}>Name</th>
                                                <th style={{ width: '12%' }}>Applied Post</th>
                                                <th style={{ width: '2%' }}>Mode</th>
                                                <th style={{ width: '10%' }}>Payment Date</th>
                                                <th style={{ width: '5%' }}>Payment ID</th>
                                                <th style={{ width: '4%' }}>Amount</th>
                                                <th style={{ width: '2%' }}>Status</th>
                                                <th style={{ width: '2%' }}>Code</th>
                                                <th style={{ width: '10%' }}>Action</th>                                
                                            </tr>
                                        </thead>
                                        <tbody className='ant-table-tbody '>
                                            
                                            {this.state.data.map((item, index) => (

                                                <tr data-index={index} key={item.Id} className=' ant-table-row'>
                                                    <td>{item.FormNumber}</td>
                                                    <td>{item.ApplicationId}</td>
                                                    <td>{item.StudentName}</td>
                                                    <td style={{ lineHeight: '15px' }}>{item.PostName}</td>
                                                    <td>{item.Method}</td>
                                                    <td>{moment(item.TransactionDate).isValid() ? moment(item.TransactionDate).format("DD MMM YYYY, h:mm:ss A") : ""}</td>
                                                    <td>{item.RazorPayPaymentId}</td>
                                                    <td>{item.Amount && (item.Amount/100)}</td>
                                                    <td className='text-center'>
                                                        <StatusBadge status={item.TransactionStatus} />
                                                    </td>
                                                    <td>{item.Error_Code}</td>
                                                    <td>{item.Error_Reason}</td>

                                                </tr>
                                            ))}
                                        </tbody>

                                    </table>
                                    
                                    {!this.state.data.length ?
                                        <EmptyState icon="inbox" title="No Records Found" description="No transactions match the current search criteria." />
                                        : ""}
                                    </div>
                                    <div className="ant-table-footer ">
                                        <label style={{ textAlign: 'right', marginRight: '20px', paddingTop: '6px' }}>Total Records: {this.state.totalRowCount}</label>        
                                    </div>
                                </div>
                                
                            </div>
                            <Pagination
                                showSizeChanger
                                pageSizeOptions= {['100', '200', '300', '500', '1000']}
                                onShowSizeChange={this.onShowSizeChange}
                                onChange={this.onPageChange}
                                defaultCurrent={this.state.pagination.current}
                                total={this.state.pagination.total}
                                pageSize={this.state.pagination.pageSize}
                                className="ant-table-pagination mini"
                            />  
                        </div>   
                        {this.state.showMessageBox ? refundModel : <></>}         
                </div>
 
        )

    };
}

export default TransactionsList_new;